import React, { useContext } from "react";
import styled from "styled-components";
import NavigationContext from "./NavigationContext";

const HomeButtonWrapper = styled.button`
  position: absolute;
  top: 1rem;
  left: 1rem;

  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 50%;
  padding: 0.4rem;

  display: flex;
  align-items: center;
  justify-content: center;

  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};
  pointer-events: ${(props) => (props.disabled ? "none" : "auto")};
  transition: background 0.2s;

  &:hover {
    background: ${(props) => (props.disabled ? "white" : "#f3f4f6")};
  }
`;

const HomeIcon = styled.img`
  width: 22px;
  height: 22px;
`;

const HomeButton = () => {
  const { navigateHome, disableHome } = useContext(NavigationContext);

  return (
    <HomeButtonWrapper
      disabled={disableHome}
      onClick={() => {
        if (!disableHome) navigateHome();
      }}
    >
      <HomeIcon src="/home.png" alt="Home" />
    </HomeButtonWrapper>
  );
};

export default HomeButton;
